<template>
  <div class="modal-container">
    <div class="add-box clearfix">
      <table-header
          @add="insertEvent"
          @remove="removeEvent"
          @copy="paste"
      ></table-header>
      <vxe-table
          border
          show-overflow
          show-footer
          ref="xTable"
          class="table-style"
          max-height="450"
          :auto-resize="true"
          :data="tableData"
          :edit-rules="formRules"
          :edit-config="{ trigger: 'click', mode: 'cell' }"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @scroll="clearV"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="no" title="序号" width="110">
          <template v-slot="scope">
            <vxe-input
                v-model="scope.row.no"
                placeholder="请输入序号"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="ordersNum" title="订单编号" width="137">
          <template v-slot:header>
            <span style="color: red">*</span>订单编号
          </template>
          <template v-slot="{ row, $rowIndex }">
            <a
                class="sel-link"
                @click="openLink({ i: $rowIndex, data: tableData })"
                target="_black"
                style="cursor: pointer"
            >
              {{
              row.ordersNum
              ? row.ordersNum
              : "选择关联订单"
              }}
            </a>
          </template>
        </vxe-table-column>
        <vxe-table-column
            title="结算类型"
            width="140"
            field="paymentType"
        >
          <template v-slot:header>
            <span style="color: red">*</span>结算类型
          </template>
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.paymentType"
                placeholder="请选择"
                transfer
                d
            >
              <vxe-option :value=1 label="托运人结算"></vxe-option>
              <vxe-option :value=2 label="承运人结算"></vxe-option>
            </vxe-select>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <span style="color: red">*</span>结算时间
        </template>
        <vxe-table-column field="paymentTime" title="结算时间">
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.paymentTime"
                placeholder="选择日期"
                type="date"
                transfer
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="amount" title="结算金额">
          <template v-slot:header>
            <span style="color: red">*</span>结算金额
          </template>
          <template v-slot="{ row }">
            <vxe-input
                v-model="row.amount"
                placeholder="必填"
            ></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="note" title="摘要">
          <template v-slot:header>
            <span style="color: red">*</span>摘要
          </template>
          <template v-slot="{ row }">
            <vxe-select v-model="row.note" :options="noteList" transfer></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="remark" title="备注">
          <template v-slot="{ row }">
            <vxe-input v-model="row.remark" placeholder="选填"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="fileList" title="上传附件" width="150">
          <template v-slot="{ row }">
            <upload-list
                :row="row"
                :initFileList="row.fileList"
                :view="'packup'"
            ></upload-list>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button status="primary" @click="impotEvent"
      >上传导入文件
      </Button
      >
      <Button status="primary" @click="save">提 交</Button>
    </div>
    <vxe-modal v-model="orderVisible" title="选择订单" width="1450" height="600" resize remember position="center">
      <choose-order
          ref="orderModal"
          @choose="chooseOrder"
      ></choose-order>
    </vxe-modal>
    <vxe-modal
        v-model="messageVisible"
        title="消息提示"
        width="600"
        position="center"
        height="350"
        @close="closeMessage"
        remember
    >
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
  import Message from "@/components/common/Message";
  import $api from "@/apiProvider";
  import XLSX from "xlsx";
  import {
    getExcelTime,
    showLoading,
    hideLoading,
    isEmpty,
    isNotEmpty,
  } from "@/utils/util";

  import UploadList from "@/components/common/UploadList";
  import TableHeader from "../../common/TableHeader";
  import ChooseOrderTwo from "@/components/modal/ChooseOrderTwo";
  import ChooseReceivingOrder from "@/components/modal/ChooseReceivingOrder";
  import ChooseOrder from "@/components/modal/ChooseOrderNew";

  var appData = require("@/assets/json/zz.json");

  export default {
    props: ["orderId"],
    components: {
      UploadList,
      TableHeader,
      Message,
      ChooseOrder: ChooseOrder,
    },
    data() {
      return {
        formRules: {
          ordersNum: [{required: true, message: "请选择关联订单"}],
          amount: [{required: true, message: "请结算金额"}],
          paymentType: [{required: true, message: "请选择结算类型"}],
          paymentTime: [{required: true, message: "请选择时间"}],
          note: [{required: true, message: "请选择摘要"}],
        },
        messageVisible: false,
        tableData: [
          {
            no: 1,
            amount: null, //起运地
            paymentType: null, //起运时间
            paymentTime: null, //车船号
            note: null, //备注
            fileList: [],
            fileUuidList: [],
          }
        ],
        info: null,
        orderVisible: false,
        message: "",
        records: [],
        noteList: []
      };
    },
    mounted() {
      this.getDictByCodeP(58000);
    },
    methods: {
      async getDictByCodeP(code) {
        let res = await $api.dict.get("searchDic", {
          parentcode: code
        });
        if (res.status === 1) {
          let data = res.data;
          let arr = [];
          data.map(i => {
            arr.push({
              label: i.dictText,
              value: i.dictText,
            })
          })
          this.noteList = arr;
        } else {
          this.$XModal.message(res.message);
        }
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      setExport(boolean) {
        this.isExport = boolean;
        this.getDicDate();
      },
      impotEvent() {
        this.$refs.xTable
          .readFile({
            types: ["xls", "xlsx"]
          })
          .then(evnt => {
            showLoading();
            const tableData = [];
            const files = evnt.target.files;
            const fileReader = new FileReader();
            fileReader.onload = async ev => {
              const data = ev.target.result;
              const workbook = XLSX.read(data, {type: "binary"});
              const csvData = XLSX.utils.sheet_to_csv(
                Object.values(workbook.Sheets)[0]
              );
              if (csvData.split("\n").length > 302) {
                hideLoading();
                this.$XModal.alert({
                  message: "本次导入数据超过300条",
                  status: "error",
                });
                return
              }
              csvData.split("\n").forEach((vRow, index) => {
                if (vRow && index > 0) {
                  const vCols = vRow.split(",");
                  let item = {
                    no: index,
                    ordersNum: vCols[1],
                    paymentTime: getExcelTime(vCols[3]),
                    amount: vCols[4], //规格
                    note: vCols[5],
                    remark: vCols[6]
                  };

                  if (vCols[2] === "托运人结算") {
                    item.paymentType = 1;
                  } else if (vCols[2] === "承运人结算") {
                    item.paymentType = 2;
                  }
                  tableData.push(item);
                  this.tableData = tableData;
                }
              });
            };
            fileReader.readAsBinaryString(files[0]);
            setTimeout(() => {
              hideLoading();
              // if (isHaveErr) {
              //   this.$XModal.alert({
              //     message: "第" + errTimeLine + "行，日期格式错误",
              //     status: "error"
              //   });
              //   isHaveErr = false;
              // }
            }, 1000);
          });
      },
      async validEvent() {
        let errMap = await this.$refs.xTable.validate().catch(errMap => errMap);
        return errMap ? false : true;
      },
      paste() {
        let records = this.records.sort((a, b) => a.no - b.no);
        if (records.length > 0) {
          records.map(i => {
            let record = Object.assign({}, i);
            record.no = this.$refs.xTable.data.length + 1;
            this.pushIntoTable(record);
          });
        } else {
          this.$XModal.message({
            status: "error",
            message: "请选择需要复制的信息！"
          });
        }
      },
      pushIntoTable(record) {
        let {row: newRow} = this.$refs.xTable.insertAt(record, -1);
        this.$refs.xTable.data.push(record);
      },
      insertEvent() {
        let record = {
          no: this.$refs.xTable.data.length + 1,
          amount: null, //起运地
          paymentType: null, //起运时间
          paymentTime: null, //车船号
          note: null, //备注
          fileList: [],
          fileUuidList: [],
        };
        this.pushIntoTable(record);
      },
      clearTableV() {
        this.$refs.xTable.clearValidate();
      },
      removeEvent() {
        let records = this.records;
        if (records.length > 0) {
          if (this.$refs.xTable.tableData.length > 1) {
            this.$XModal.confirm("您确定要删除选中数据?").then(type => {
              if (type === "confirm") {
                this.clearV();
                records.map(i => {
                  this.$refs.xTable.remove(i);
                  let key = this.$refs.xTable.data.indexOf(i);
                  this.$refs.xTable.data.splice(key, 1);
                });
                this.records = [];
                if (this.isExport === false) {
                  this.$refs.xTable.data.map((j, index) => {
                    j.no = index + 1;
                  });
                }
              }
            });
          } else {
            this.$XModal.alert({
              message: "已经是最后一条了！",
              status: "warning"
            });
          }
        } else {
          this.$XModal.message({
            status: "error",
            message: "请选择需要删除的信息！"
          });
        }
      },
      clearV() {
        this.$refs.xTable.clearValidate();
      },
      async save() {
        let sts = await this.validEvent();
        if (!sts) {
          this.$XModal.message({status: "error", message: "校验不通过！"});
          return;
        }
        // let isCanNotSubmit = false;
        let arr = JSON.parse(JSON.stringify(this.tableData));
        arr.map(i => {
          i.paymentTime = this.$utils.timestamp(i.paymentTime);
          if (i.fileList) {
            i.fileList.forEach(item => {
              item.sourceType = 1;
            })
          }
        });
        showLoading();
        let res = await $api.twoSettlement.request("batchCreate", arr);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success("提交成功");
          this.close();
          this.$emit("createCommit", false);
        } else {
          let data = res.data;
          let message = "";
          if (data !== undefined && data.length > 0) {
            data.map(i => {
              message =
                message +
                "序号" +
                this.tableData[i.failArrayIndex].no +
                "，" +
                i.failMsg +
                "\n";
            });
            // let errorData = [];
            // res.data.forEach(failItem => {
            //   errorData.push(
            //       Object.assign({}, this.tableData[failItem.failArrayIndex])
            //   );
            // });
            // this.tableData = errorData;
          }
          if (message === "") {
            this.$XModal.alert({
              message: "接口异常",
              status: "error"
            });
          } else {
            this.messageVisible = true;
            this.$refs.messageModal.setMessage(message);

          }
        }
      },
      close() {
        this.tableData = [
          {
            no: 1,
            amount: null, //起运地
            paymentType: null, //起运时间
            paymentTime: null, //车船号
            note: null, //备注
            fileList: [],
            fileUuidList: [],
          }
        ];
        this.clearV();
        this.records = [];
      },
      //选择订单
      chooseOrder(row) {
        let data = this.info.data;
        let i = this.info.i;
        data[i].ordersNum = row.ordersNum;
        this.orderVisible = false;
      },
      openLink(obj) {
        this.info = obj;
        this.$refs.orderModal.init();
        this.orderVisible = true;
      },
      closeMessage() {
        this.messageVisible = false;
      },
    }
  };
</script>

<style>
  .modal-container {
    position: relative;
    height: 100%;
  }

  .modal-footer {
    padding: 10px 0 0 0;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    position: absolute;
    bottom: 0;
  }

  .add-btn {
    width: 20px;
    height: 20px;
    color: #fff;
    line-height: 20px;
    background-color: #2d8cf0;
    border: none;
    border-radius: 0;
  }
</style>